module.exports = __webpack_public_path__ + "static/media/Edit-Circle.4600f331.svg";